import { Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { MangoButtonVariant } from '~/components/shared/componentStyles/MangoButton.style'
import { MangoButton } from '~/components/shared/MangoButton'
import { useElectronUpdaterContext } from '~/providers/ElectronUpdaterContext'
import { Size } from '~/types/ThemeTypes'
import { isElectron } from '~/utils/common'

const UpdaterButton = () => {
  const {
    statusMessage,
    isUpdateDownloaded,
    isChecking,
    error,
    checkForUpdates,
    quitAndInstall,
  } = useElectronUpdaterContext()

  if (error) {
    console.error(error)
  }

  return (
    <>
      {isElectron && (
        <Flex
          flexDirection={'column'}
          alignItems={'center'}
          justifyContent={'center'}
          marginBottom={1}
          marginTop={1}
        >
          <Text
            color={error ? 'red.700' : 'gray.800'}
            height={'auto'}
            maxHeight={'3rem'}
            lineHeight={'1.15rem'}
            overflowY={'auto'}
          >
            {!error && (statusMessage || ' ')}
            {error && 'An error occurred while checking for updates.'}
          </Text>
          {isUpdateDownloaded && (
            <MangoButton
              marginTop={2}
              size={Size.sm}
              variant={MangoButtonVariant.Destructive_300}
              onClick={quitAndInstall}
            >
              Restart & Update
            </MangoButton>
          )}
          {!isUpdateDownloaded && (
            <MangoButton
              disabled={isChecking}
              marginTop={2}
              size={Size.sm}
              variant={MangoButtonVariant.Success_300}
              onClick={checkForUpdates}
              isLoading={isChecking}
            >
              Check for Updates
            </MangoButton>
          )}
        </Flex>
      )}
    </>
  )
}

export default UpdaterButton
